module.exports = __webpack_public_path__ + "static/media/18.jpg.a52e4713.webp";